import { render, staticRenderFns } from "./companyLogoIcon.vue?vue&type=template&id=04090462&"
import script from "./companyLogoIcon.vue?vue&type=script&lang=js&"
export * from "./companyLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports